import React, { useState } from 'react';
import { Box } from '@mui/material';
import CodeManagementHeader from './components/MasterManagementHeader';
import PCode from './components/PCode';
import FCode from './components/FCode';
import RCode from './components/RCode';
import { CODE_MASTER_SELECTION } from '../../_constants/manageConst';
import RCodeRepairParts from './components/RCodeRepairParts';

const ManageCodeMaster: React.FC = () => {
  // 表示されているマスター
  const [masterType, setMasterType] = useState<number>(-1);

  return (
    <Box mt={8}>
      <CodeManagementHeader
        masterType={masterType}
        updateMasterType={setMasterType}
      />
      {masterType === CODE_MASTER_SELECTION.P_CODE.id && <PCode />}
      {masterType === CODE_MASTER_SELECTION.F_CODE.id && <FCode />}
      {masterType === CODE_MASTER_SELECTION.R_CODE.id && <RCode />}
      {masterType === CODE_MASTER_SELECTION.R_CODE_REPAIR_PARTS.id && (
        <RCodeRepairParts />
      )}
    </Box>
  );
};

export default ManageCodeMaster;
